<template>
    <div>
        <fluke-card>
            <header v-if="permission.write">
                <div class="title">Editar Curso</div>
                <div class="description">Altere as informações do curso</div>
            </header>
            <header v-else>
                <div class="title">Visualizar Curso</div>
                <div class="description">Alterações desabilitadas para este perfil</div>
            </header>
            <v-form v-model="valid" @submit.prevent ref="form">
                <main>
                    <div class="flexsplit">
                        <v-switch v-model="publish" label="Publicar" :disabled="permission.write?null:true"></v-switch>
                        <div class="flexsplit">
                            <v-switch v-model="closed" label="Encerrado" :disabled="permission.write?null:true"></v-switch>
                            <v-switch v-model="lastSpots" label="Últimas Vagas" :disabled="permission.write?null:true"></v-switch>

                        </div>
                    </div>
                    <fluke-imageuploader v-model="img" :disabled="permission.write?null:true" :key="'header'"/>

                    <v-text-field
                        label="Nome / Title"
                        v-model="title"
                        :disabled="permission.write?null:true"
                        :rules="titleRules"
                    >
                    </v-text-field>
                    <v-switch v-model="equivalentSlug" label="Slug automático" :disabled="permission.write?null:true"></v-switch>
                    <v-text-field
                        v-if="!equivalentSlug"
                        label="Slug"
                        v-model="slug"
                        :disabled="permission.write?null:true">
                    </v-text-field>
                    <p><em>Preview da URL: <strong>{{urlPreview}}</strong></em></p>
                    <v-text-field
                        label="Meta Description"
                        v-model="meta_description"
                        :disabled="permission.write?null:true">
                    </v-text-field>
                    <v-text-field
                        label="Meta Tags"
                        v-model="meta_tags"
                        :disabled="permission.write?null:true">
                    </v-text-field>

                    <div class="form-left">
                        <v-text-field
                            label="Public Alvo"
                            v-model="target"
                            class="half-form"
                            :disabled="permission.write?null:true">
                        </v-text-field>
                        <v-text-field
                            label="Pré-requisitos"
                            v-model="prerequisites"
                            class="half-form"
                            :disabled="permission.write?null:true">
                        </v-text-field>
                        <v-text-field
                            label="Certificação"
                            v-model="certification"
                            class="half-form"
                            :disabled="permission.write?null:true">
                        </v-text-field>
                        <v-text-field
                            label="Carga Horária"
                            v-model="workload"
                            class="half-form"
                            :disabled="permission.write?null:true">
                        </v-text-field>
                        <v-select
                            v-model="typeCurrent"
                            :items="types"
                            item-text="title"
                            item-value="value"
                            label="Modo"
                            required
                            class="half-form"
                            :disabled="permission.write?null:true">
                        </v-select>
                    </div>

                    <div class="form-right">
                        <left-slider v-model="sideImg" :disabled="permission.write?null:true"></left-slider>
                    </div>

                    <div class="form-clear"></div>

                    <div class="flexsplit">
                        <v-text-field
                            label="Investimento"
                            v-model="budget"
                            :disabled="permission.write?null:true">
                        </v-text-field>
                        <v-text-field
                            label="Forma de pagamento"
                            v-model="payment"
                            :disabled="permission.write?null:true">
                        </v-text-field>
                    </div>

                    <v-text-field
                        label="Localização"
                        v-model="location"
                        :disabled="permission.write?null:true"
                        :rules="locationRules"
                    >
                    </v-text-field>

                    <v-textarea
                        label="Resumo"
                        rows="2"
                        auto-grow
                        v-model="resume"
                        counter
                        maxlength="200"
                        :disabled="permission.write?null:true">
                    </v-textarea>
                    <fluke-editor v-model="description" :key="keyer" :disabled="permission.write?null:true"></fluke-editor>

                    <v-switch v-model="show_pdf" label="Exibir Download PDF" :disabled="permission.write?null:true"></v-switch>

                    <fluke-input-file
                        label="PDF"
                        accept="application/pdf"
                        :current-file="currentPDF"
                        :size="currentPDFSize"
                        :file="pdf"
                        @change="e => setFile('pdf', e)"
                        @remove="removeFile('pdf')"
                    />

                    <v-switch v-if="currentPDF" v-model="remove_pdf" label="Remover PDF atual" :disabled="disabledRemovePDF"></v-switch>

                    <br>
                    <fluke-micontent
                        v-if="!contentIsModular"
                        v-model="contentItems"
                        :disabled="permission.write?null:true"
                        :key="'c'+keyer">
                    </fluke-micontent>

                    <fluke-micontent-modules
                        v-else
                        v-model="contentItemsModules"
                        :disabled="permission.write?null:true"
                        :key="'cm'+keyer">
                    </fluke-micontent-modules>

                    <fluke-mi
                        v-model="theySayItems"
                        :disabled="permission.write?null:true"
                        :key="'ts'+keyer" />

                    <upcoming-dates :disabled="permission.write?null:true" />

                    <faq-items :disabled="permission.write?null:true" />

                    <fluke-miinstructors
                        v-model="instItems"
                        :key="'inst'+keyer"
                        :disabled="permission.write?null:true" />

                </main>
                <footer>
                    <fluke-button v-on:click.native="cancel" color="grey" :disabled="sending">cancelar</fluke-button>
                    <fluke-button v-on:click.native="submit" v-if="permission.write" :disabled="sending">Salvar</fluke-button>
                </footer>
            </v-form>
        </fluke-card>

        <div class="right" v-if="permission.write">
            <a v-on:click="remove" class="remove-links">Remover Curso</a>
        </div>
        <global-popup ref="remove" title="Remover">Deseja remover o curso?</global-popup>
        <global-popup ref="alert" title="Alerta!">{{alertMessage}}</global-popup>
    </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';
import ImageUploader from '../../components/Main/Content/ImageUploader/ImageUploader';
import LeftSlider from '../../components/Main/Content/LeftSlider/LeftSlider';
import Editor from '../../components/Main/Content/Editor/Editor';
import MultipleInfo from '../../components/Main/Content/MultipleInfo/MultipleInfo';
import MultipleInfoDates from '../../components/Main/Content/MultipleInfo/MultipleInfoDates';
import MultipleInfoContent from '../../components/Main/Content/MultipleInfo/MultipleInfoContent';
import MultipleInfoContentModules from '../../components/Main/Content/MultipleInfo/MultipleInfoContentModules';
import MultipleInfoInstructors from '../../components/Main/Content/MultipleInfo/MultipleInfoInstructors';
import InputFile from '../../components/Main/Content/InputFile/InputFile';

import UpcomingDates from './Edit/UpcomingDates';
import FAQ from './Edit/Faq';

import permission from '../../mixins/permissions';


export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button,
        'fluke-imageuploader': ImageUploader,
        'fluke-editor': Editor,
        'fluke-mi': MultipleInfo,
        'fluke-midates': MultipleInfoDates,
        'fluke-micontent': MultipleInfoContent,
        'fluke-micontent-modules': MultipleInfoContentModules,
        'fluke-miinstructors': MultipleInfoInstructors,
        LeftSlider,
        'faq-items': FAQ,
        'upcoming-dates': UpcomingDates,
        'fluke-input-file': InputFile
    },
    data: function() {
        return {
            budget: '',
            certification:'',
            closed: 0,
            course:'',
            contentIsModular: false,
            contentItems: [],
            contentItemsModules: [],
            description: '',
            datesItems: [],
            externalUrl: '',
            id: null,
            img: '',
            isSigninWithUrl: false,
            instItems: [],
            keyer: 0,
            location: '',
            lastSpots: 0,
            meta_description: '',
            meta_tags: '',
            payment: '',
            publish: false,
            prerequisites: '',
            resume: '',
            sideImg: [],
            title: '',
            target:'',
            types: [
                { title: 'Presencial', value: 'presencial' },
                { title: 'On-line', value: 'online' }
            ],
            typeCurrent: 'online',
            theySayItems: [],
            workload: '',
            permission: {
                read: false,
                write: false
            },
            show_pdf: false,
            pdf: null,
            currentPDF: null,
            currentPDFSize: null,
            sending: false,
            alertMessage: '',
            slug: null,
            equivalentSlug: true,
            remove_pdf: false,
            valid: false,
            titleRules: [
                v => !!v || 'Digite o título'
            ],
            locationRules: [
                v => !!v || 'Digite a localização'
            ],
        }
    },
    async created(){
        await this.getData();
        this.permission = this.getUserPagePermission('courses');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    watch: {
        lastSpots: function()
        {
            if( this.lastSpots && this.closed ) this.closed = false;
        },
        closed: function()
        {
            if( this.lastSpots && this.closed ) this.lastSpots = false;
        },
        title: function (value)
        {
            if (this.equivalentSlug) {
                this.slug = this.createSlug(value)
            }
        },
        slug: function (value, oldValue)
        {
            this.$nextTick(() => {
                if (value !== oldValue && value && oldValue) {
                    const acceptdChars = [' ', '-']
                    const lastOldChar = oldValue[oldValue.length - 1]
                    const lastChar = value[value.length - 1]
                    const prependChar = acceptdChars.includes(lastChar)
                        ? '-'
                        : ''
                    this.slug = this.createSlug(value) + prependChar
                }
            })
        },
        equivalentSlug: function (value)
        {
            if (value) {
                this.slug = this.createSlug(this.title)
            }
        }
    },
    methods: {
        dateCompare: function(date1, date2)
        {
            var d1 = date1.beginDate;
            var d2 = date2.beginDate;
            var comparison = 0;

            if( d1 > d2 ) comparison = 1;
            else if( d1 < d2 )comparison = -1;

            return comparison;
        },
        getData: async function(){
            this.id = this.$route.params.id;
            const result = await axios.get(
				this.$myServerAddresses.courses + 'courses/' + this.id, {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.title = result.data.title;
            this.slug = result.data.slug;
            this.equivalentSlug = this.slug === this.createSlug(this.title)
            this.description = result.data.description;
            this.resume = result.data.resume;
            this.img = result.data.img;
            this.sideImg = ( result.data.side_img == null || result.data.side_img === '[]' )?[]:((result.data.side_img.search('{') == -1 )?result.data.side_img:JSON.parse(result.data.side_img));
            this.workload = result.data.workload;
            this.typeCurrent = result.data.mode; // == 'online')?{ title: 'On-line', value: 'online' }:{ title: 'Presencial', value: 'presencial' };
            this.theySayItems = JSON.parse(result.data.theysay);
            this.datesItems = ( result.data.dates == null )?[]:JSON.parse(result.data.dates);
            if(this.datesItems && this.datesItems.length)
            {
                this.datesItems.sort(this.dateCompare);
            }
            // Definindo data inicial : begin
            const today = (new Date()).toJSON().substring(0,10);

            const dates = ( result.data.dates == null || result.data.dates == 'null' )
                ? []
                : JSON.parse(result.data.dates);
            const activeDates = dates.filter( el => {
                var date;
                if(el.type == 'multiple'){
                    date = el.data[0].date;
                } else {
                    date = el.data.date;
                }
                return date.split('/').reverse().join('-') > today;
            });
            if( dates && dates.length && activeDates && activeDates.length == 0 ) {
                this.closed = 1;
            } else {
                this.closed = result.data.closed;
            }

            this.instItems = JSON.parse(result.data.instructors);
            this.publish = result.data.publish;
            this.course = result.data.course;
            this.target = result.data.target;
            this.location = result.data.location;
            this.certification = result.data.certification;
            this.externalUrl = result.data.external_url;
            this.budget = result.data.budget;
            this.payment = result.data.payment;
            this.prerequisites = result.data.prerequisites;
            this.lastSpots = result.data.last_spots;
            this.lastSpots = result.data.last_spots;
            this.meta_description = result.data.meta_description;
            this.meta_tags = result.data.meta_tags;

            //
            var preContent = ( result.data.content == null )?'':JSON.parse(result.data.content);
            if( typeof preContent.isPlain !== 'undefined' && preContent.isPlain == "true" )
            {
                this.contentIsModular = false;

                if( typeof preContent.plain !== 'undefined' )
                {
                    this.contentItems = preContent.plain;
                }
                else
                {
                    this.contentItems = [];
                }
            }
            else
            {
                this.contentIsModular = true;

                if( typeof preContent.modules !== 'undefined' )
                {
                    this.contentItemsModules = preContent.modules;
                }
                else
                {
                    this.contentItemsModules = [];
                }
            }
            this.keyer += 1;

            //bug fix
            if( result.data.side_img == null ) result.data.side_img = []

            this.show_pdf = result.data.show_pdf

            if (result.data.pdf) {
                this.currentPDF = this.$myServerAddresses.courses + 'files/' + result.data.pdf
                this.currentPDFSize = +result.data.pdf_size
            }

            console.log( result.data )

            this.$store.commit(
                'set_course_data',
                result.data
            );
        },
        validate () {
            let messages = []
            let result = true
            if (
                this.$store.state.course.data.dates == null ||
                this.$store.state.course.data.dates.length == 0
            ) {
                messages.push('Adicione ao menos um item em Próximas datas')
                result = false
            }
            if (!result) {
                this.$store.commit(
                    'flash_warning',
                    messages.join(', ')
                );
                return false
            }
            result = this.$refs.form.validate()
            if (!result) {
                this.$store.commit(
                    'flash_warning',
                    'Existe algum campo preenchido incorretamente, por favor verifique'
                );
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
            return result
        },
        submit: async function() {
            if (!this.validate()) return false

            this.sending = true

            if (this.$store.state.course.faqItems.length > 0) {
                await axios.post(
                    this.$myServerAddresses.courses + 'faq/items',
                    {
                        items: this.$store.state.course.faqItems.map( (el,index) => {
                            return {
                                id: el.id,
                                position: index
                            }
                        }),
                        course_id: this.id
                    },
                    {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        }
                    }
                );
            }

            const resultUploads = await this.uploadFiles()
            if (resultUploads) {
                var precontent = {
                    isPlain: !this.contentIsModular?"true":"false",
                    plain: this.contentItems,
                    modules: this.contentItemsModules
                }

                const result = await axios.put(
                    this.$myServerAddresses.courses + 'courses',
                    {
                        id: this.id,
                        title: this.title,
                        description: this.description,
                        resume: this.resume,
                        workload: this.workload,
                        mode: this.typeCurrent,
                        budget: this.budget,
                        payment: this.payment,
                        location: this.location,
                        prerequisites: this.prerequisites,
                        theysay: JSON.stringify(this.theySayItems),
                        dates: JSON.stringify(this.$store.state.course.data.dates),
                        content: JSON.stringify(precontent),
                        questions: JSON.stringify(this.$store.state.course.faqItems),
                        instructors: JSON.stringify(this.instItems),
                        img: this.img,
                        publish: this.publish,
                        target: this.target,
                        course: this.course,
                        certification: this.certification,
                        external_url: this.externalUrl,
                        side_img: JSON.stringify(this.sideImg),
                        closed: this.closed,
                        last_spots: this.lastSpots,
                        meta_tags: this.meta_tags,
                        meta_description: this.meta_description,
                        show_pdf: this.show_pdf,
                        slug: this.slug,
                        remove_pdf: this.remove_pdf,
                    },
                    {
                        headers: {
                            'X-Fluke': this.$cookies.get('token')
                        }
                    }
                );

                if (result.data) {
                    this.$router.push({ name: 'courses' });
                } else {
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                    this.$store.commit(
                        'flash_warning',
                        'Existe algum campo preenchido incorretamente, por favor verifique'
                    );
                    this.sending = false
                }
            } else {
                this.sending = false
                this.$refs.alert.alert();
            }
        },
        remove: async function () {

            this.$refs.remove
                .confirm()
                .then(()=>{
                    axios.delete(
                        this.$myServerAddresses.courses + 'courses/' + this.id,
                        {
                            headers: {
                                'X-Fluke': this.$cookies.get('token')
                            }
                        }
                    ).then(()=>{
                        this.$router.push({ name: 'courses' });
                    });
                });
        },
        cancel: function() {
            this.$router.push({ name: 'courses' });
        },
        setFile: function (field, event) {
            this[field] = event.target.files[0]
            if (field === 'pdf') {
                this.remove_pdf = false
            }
        },
        removeFile: function (field) {
            this[field] = null
        },
        uploadFiles: async function () {
            const messages = []
            let sended = true
            const fileFields = [{
                field: 'pdf',
                label: 'PDF'
            }]
            for (const item of fileFields) {
                const value = this[item.field]
                if (value) {
                    const result = await this.uploadFile(item.field, value)
                    if (result && sended) {
                        sended = true
                    } else {
                        sended = false
                        messages.push(`Não foi possível fazer upload do ${item.label}`)
                    }
                }
            }
            this.alertMessage = messages.join(', ')
            return sended
        },
        uploadFile: async function (field, file) {
            try {
                var formData = new FormData();
                formData.set('id', this.$route.params.id);
                formData.append(field, file);
                    const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'X-Fluke': this.$cookies.get('token')
                    }
                };
                const url = this.$myServerAddresses.courses + 'courses/upload-file'
                const result = await axios.put(url, formData, config)
                return result.data
            } catch (error) {
                return false
            }
        },
        createSlug: value => {
            return _.kebabCase(value)
        }
    },
    computed: {
        urlPreview () {
            const url = [
                '',
                'curso',
                this.typeCurrent,
                this.slug
            ]
            return url.join('/')
        },
        disabledRemovePDF () {
            if (this.permission.write) {
                return !!this.pdf
            }
            return true
        }
    }
}
</script>


<style lang="scss">
.editable_list_item {
    margin-bottom: 20px;

    .item_title {
        font-weight: 600;
        font-size: 14px;
        margin-bottom: 20px;
    }
}
</style>
